export default function TableHeaderEntry({ text }) {
  return <th className="py-2 px-4 border-b text-white">{text}</th>;
}
